// @flow
import { type GlobalStateType } from 'Lib/reduxType';

export function isVersionMismatch(inboundVersion?: number, currentVersion?: number) {
  return currentVersion != null && inboundVersion !== currentVersion;
}

export function createMigrate(migrations: {
  [key: number]: (value: GlobalStateType) => GlobalStateType,
}) {
  return function migrate(
    state: GlobalStateType,
    inboundVersion?: number,
    currentVersion?: number
  ): ?GlobalStateType {
    // If the version does not match, migrate or discard
    if (isVersionMismatch(inboundVersion, currentVersion)) {
      return inboundVersion != null && migrations && migrations[inboundVersion]
        ? migrations[inboundVersion](state)
        : undefined;
    }

    // Otherwise use as-is
    return state;
  };
}

export default function defaultMigrate(
  state: GlobalStateType,
  inboundVersion?: number,
  currentVersion?: number
) {
  return isVersionMismatch(inboundVersion, currentVersion) ? undefined : state;
}
